import { render, staticRenderFns } from "./PendingBillingTable.vue?vue&type=template&id=47e72954&"
import script from "./PendingBillingTable.vue?vue&type=script&lang=js&"
export * from "./PendingBillingTable.vue?vue&type=script&lang=js&"
import style0 from "./PendingBillingTable.vue?vue&type=style&index=0&id=47e72954&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports